import { StyleSheet } from 'react-native';
import {
  defaultWidth,
  fontSizeMedium,
  editLinkColor,
  bold,
} from '../../../constants/palette';

export default StyleSheet.create({
  buttonContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  header: {
    textAlign: 'center',
    width: defaultWidth,
  },
  platformText: {
    marginBottom: 20,
    fontSize: fontSizeMedium,
    width: defaultWidth,
    textAlign: 'center',
  },
  editLinkText: {
    color: editLinkColor,
    fontWeight: bold,
    fontSize: fontSizeMedium,
  },
});
